module.exports = __webpack_public_path__ + "img/player_jump_004.cdee192c.png";